export type QualityLevel = 'high' | 'low';

const STORAGE_KEY = 'imbasion_quality';

function safeStorage(): Storage | null {
  try {
    return window?.localStorage ?? null;
  } catch {
    return null;
  }
}

export function getQuality(): QualityLevel {
  const storage = safeStorage();
  const value = storage?.getItem(STORAGE_KEY);
  if (value === 'low' || value === 'high') return value;
  return 'high';
}

export function setQuality(level: QualityLevel): void {
  const storage = safeStorage();
  storage?.setItem(STORAGE_KEY, level);
}

export function isLowQuality(): boolean {
  return getQuality() === 'low';
}
